import React, {useCallback} from "react";
import "./DeliveryProviderForm/upload-delivery-provider-form.css";
import {DeliveryProviderForm} from "./DeliveryProviderForm/DeliveryProviderForm.jsx";
import {useFormStateHook} from "../../../components/form/hook.jsx";
import {updateDeliveryProvider} from "../../../api/deliveryProvider/adminDeliveryProvider.js";
import {message, Spin} from "antd";
import {isEmpty} from "lodash";

export const EditDeliveryProvider = ({deliveryProvider, onSuccess, isLoading}) => {
    const {formValues, onFormValueChange} = useFormStateHook([]);

    const onSave = useCallback(async () => {
        const {errors, ...deliveryProviderValues} = formValues;
        try {
            if (isEmpty(deliveryProviderValues)) {
                return;
            }

            const deliveryProviderUpdate = await updateDeliveryProvider(
                deliveryProvider?.deliveryProviderId,
                deliveryProviderValues
            );

            if (deliveryProviderUpdate?.error) {
                message.error(deliveryProviderUpdate?.error);
                return;
            }

            onSuccess();
        } catch (e) {
            message.error(e?.message);
        }
    }, [deliveryProvider?.deliveryProviderId, formValues, onSuccess]);

    return (
        <>
            {isLoading ? (
                <Spin style={{width: "100%"}} />
            ) : (
                <DeliveryProviderForm
                    formValues={{...deliveryProvider, ...formValues}}
                    setFormValues={onFormValueChange}
                    onSave={onSave}
                />
            )}
        </>
    );
};
